import styled from 'styled-components';

export const BlogContainer = styled.div`
  min-height: 100vh;
  padding: 120px 0 80px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);

  @media (max-width: 768px) {
    padding: 100px 0 60px;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const BlogHeader = styled.header`
  text-align: center;
  margin-bottom: 60px;
  padding: 40px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 30px 15px;
    margin-bottom: 40px;
  }
`;

export const BlogTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

export const BlogSubtitle = styled.p`
  font-size: 1.125rem;
  color: #64748b;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const BlogContent = styled.main`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const ArticleSection = styled.article`
  background: white;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
  }

  @media (max-width: 480px) {
    padding: 20px 15px;
  }
`;

export const ArticleTitle = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 20px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

export const ArticleContent = styled.div`
  p {
    font-size: 1.0625rem;
    line-height: 1.8;
    color: #475569;
    margin-bottom: 20px;
    text-align: justify;

    @media (max-width: 480px) {
      font-size: 1rem;
      text-align: left;
    }
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const KeywordHighlight = styled.strong`
  color: #2563eb;
  font-weight: 600;
  background: linear-gradient(120deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);
  padding: 2px 6px;
  border-radius: 4px;
`;

export const LocationTag = styled.strong`
  color: #059669;
  font-weight: 600;
  background: linear-gradient(120deg, rgba(5, 150, 105, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%);
  padding: 2px 6px;
  border-radius: 4px;
`;

export const ServicesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 30px 0;
`;

export const ServiceItem = styled.li`
  padding: 15px 20px;
  margin-bottom: 15px;
  background: #f8fafc;
  border-left: 4px solid #2563eb;
  border-radius: 8px;
  font-size: 1.0625rem;
  line-height: 1.6;
  color: #475569;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  strong {
    color: #1e293b;
    font-weight: 600;
  }

  @media (max-width: 480px) {
    padding: 12px 15px;
    font-size: 1rem;
  }
`;

export const CtaSection = styled.section`
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  padding: 50px 40px;
  border-radius: 16px;
  text-align: center;
  color: white;
  margin-top: 40px;
  box-shadow: 0 10px 40px rgba(37, 99, 235, 0.3);

  h2 {
    font-size: 2rem;
    margin-bottom: 20px;
    color: white;

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  p {
    font-size: 1.125rem;
    line-height: 1.8;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 0.95);
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 768px) {
      font-size: 1rem;
    }

    ${KeywordHighlight} {
      color: white;
      background: transparent;
      font-weight: 700;
    }

    ${LocationTag} {
      color: white;
      background: transparent;
      font-weight: 700;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }

  @media (max-width: 480px) {
    padding: 30px 20px;
  }
`;

export const CtaButton = styled.a`
  display: inline-block;
  padding: 16px 40px;
  background: white;
  color: #2563eb;
  font-weight: 600;
  font-size: 1.125rem;
  text-decoration: none;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  margin-right: 1rem;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    background: #f8fafc;
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    padding: 14px 30px;
    font-size: 1rem;
    width: 100%;
    text-align: center;
    margin-right: 0;
  }
`;

